import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  adminTypeListController,
  changeStatusRoleController,
} from "../../services/subAdminServices/subAdminServices";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useButtonLoader from "../../hooks/useButtonLoader";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import { Checkbox, FormControlLabel } from "@mui/material";
import ToggleStatus from "../../common/ToggleStatus";
import ModalBox from "../../common/ModalBox";

const RoleManagement = () => {
  const [roleList, setRoleList] = useState([]);
  const [roleId, setRoleId] = useState(null);
  const [statusModal, setStatusModal] = useState(false);
  const [limit, setLimit] = useState(10);
  const [startNumber, setStartNumber] = useState(1);
  const [search, setSearch] = useState("");
  const [totalList, setTotalList] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [loader, show, hide] = useFullPageLoader();
  const [submitButton, setSubmitButton] = useButtonLoader();
  const navigate = useNavigate();

  // Fetch Role List
  const fetchRoleList = async () => {
    try {
      show();
      const response = await adminTypeListController(
        activePage ? activePage : "",
        limit ? limit : "",
        search ? search : ""
      );
      if (response?.data?.code === 200) {
        hide();
        const roleData = response?.data?.data?.data;
        setRoleList(roleData);
        setTotalList(response?.data?.data?.count || roleData.length);
      } else {
        hide();
        toast.error(
          response?.response?.data?.message || response?.data?.message
        );
      }
    } catch (e) {
      hide();
      console.log("Error fetching admin types:", e.message);
    }
  };

  // Role Status Handler
  const handleRoleStatus = async () => {
    try {
      setSubmitButton(true);
      const response = await changeStatusRoleController(roleId);
      if (response?.data?.code === 200) {
        toast.success(response?.data?.message);
        setStatusModal(false);
        setSubmitButton(false);
        fetchRoleList();
      } else {
        toast.error(response?.response?.data?.message);
        setStatusModal(false);
        setSubmitButton(false);
      }
    } catch (e) {
      console.log(e.message);
      setSubmitButton(false);
    }
  };

  // Handle Pagination
  const handlePageChange = (event) => {
    setActivePage(event);
  };

  useEffect(() => {
    fetchRoleList();
  }, [activePage]);

  useEffect(() => {
    setStartNumber((activePage - 1) * limit + 1);
  }, [activePage]);

  return (
    <React.Fragment>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <nav aria-label="breadcrumb"></nav>
          </div>
          <div className="page-header">
            <div className="page_title_wrap">
              <h2 className="page-title">
                <span
                  className="page-title-icon bg-gradient-primary text-white me-2"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <i className="mdi mdi-chevron-double-left"></i>
                </span>
                Role Management
              </h2>

              <div className="button_wrap">
                <Link
                  to="/sub-admin-management/create-role"
                  className="btn btn-outline-info cstm_btn_wrap_theme mx-2"
                >
                  <i className="mdi mdi-plus menu-icon menu-icon"></i>Create
                  Role
                </Link>
              </div>
            </div>
          </div>
          {loader}
          <div className="row wrap_selectCstm">
            <div className="col-lg-12 cstm_padding_set grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Role Name</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {roleList?.length > 0 ? (
                          roleList?.map(({ id, role, status }, index) => {
                            return (
                              <React.Fragment key={id}>
                                <tr>
                                  <td>{(activePage - 1) * limit + ++index}</td>
                                  <td>{role || "---"}</td>
                                  <td>
                                    <div className="action_button_wrap">
                                      <div className="switch_button">
                                        <FormControlLabel
                                          control={
                                            <ToggleStatus
                                              onClick={() => {
                                                setStatusModal(true);
                                                setRoleId(id);
                                              }}
                                              sx={{ m: 1 }}
                                              checked={status == 1}
                                            />
                                          }
                                        />
                                      </div>
                                      <Link
                                        className="action_button"
                                        to={`/sub-admin-management/viewrole/${id}`}
                                      >
                                        <VisibilityIcon
                                          className="cstm_eye"
                                          color="secondary"
                                        />
                                      </Link>
                                      <Link
                                        className="action_button"
                                        to={`/sub-admin-management/editrole/${id}`}
                                      >
                                        <i className="mdi mdi-table-edit"></i>
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={3}>
                              <div className="text-center">No roles found</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5>
                        Showing {startNumber} to{" "}
                        {startNumber + roleList?.length - 1} of {totalList}{" "}
                        entries
                      </h5>
                    </div>
                    {totalList > 10 ? (
                      <div className="pagination_wrap">
                        <Pagination
                          activePage={activePage}
                          linkClass="page-link"
                          previousLabel={"previous"}
                          nextLabel={"next"}
                          itemsCountPerPage={limit}
                          totalItemsCount={totalList}
                          pageRangeDisplayed={5}
                          itemClassLast="last_page next"
                          itemClassFirst="first_page prev"
                          activeLinkClass="active"
                          onChange={handlePageChange}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Status Change Modal */}
        <ModalBox
          status={statusModal}
          onClose={() => {
            setStatusModal(false);
          }}
          title="Change Status"
          description="Are you sure you want to change the status of this role?"
          action={handleRoleStatus}
          uploadButtonElement={setSubmitButton}
        />
      </div>
    </React.Fragment>
  );
};

export default RoleManagement;
